import React from 'react'
import { Cube } from '../geometries/Cube'
import { degreesToRadians } from '../helpers'

export const Chair = ({ position, rotation }) => {
	return (
		<group position={position} scale={[1.3, 1.3, 1.3]} rotation={[0, (Math.PI / -2) - degreesToRadians(rotation), 0]} castShadow receiveShadow>
			<Cube color='gray' position={[-10.5, 10, 10.5]} size={[3.5, 20, 3.5]} />
			<Cube color='gray' position={[-10.5, 10, -10.5]} size={[3.5, 20, 3.5]} />
			<Cube color='gray' position={[10.5, 20, 10.5]} size={[3.5, 40, 3.5]} />
			<Cube color='gray' position={[10.5, 20, -10.5]} size={[3.5, 40, 3.5]} />
			<Cube color='gray' position={[0, 20, 0]} size={[24.5, 3.5, 24.5]} />
			<Cube color='gray' position={[10.5, 38.5, 0]} size={[3.5, 3.5, 24.5]} />
		</group>
	)
}
